import { render, staticRenderFns } from "./DishEvaluate.vue?vue&type=template&id=c0035318&scoped=true"
import script from "./DishEvaluate.vue?vue&type=script&lang=js"
export * from "./DishEvaluate.vue?vue&type=script&lang=js"
import style0 from "./DishEvaluate.vue?vue&type=style&index=0&id=c0035318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0035318",
  null
  
)

export default component.exports